import React, { memo } from 'react'

import {
  Button, Close, Icon, Search, TextInput,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize, iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { closeStylePanel } from 'Pods/ThreeDStudio/Store/actions/ui'

import StyleGrid from './Components/StyleGrid/StyleGrid'
import StyleTags from './Components/StyleTags/StyleTags'
import useStylePanel from './useStylePanel'

const closeIcon = <Icon svgComponent={Close} size={iconSizeMedium} notSpaced />
const searchIcon = <Icon svgComponent={Search} size={iconSize} color="dark" notSpaced />

function StylePanel() {
  const t = useTranslation()
  const {
    query,
    activeTagId,
    visibleStyles,
    selectedStyleId,
    isLoading,
    isError,
    handleQueryChange,
    handleSelectTag,
    handleSelectStyle,
  } = useStylePanel()

  return (
    <div
      className="style-panel"
      role="dialog"
      aria-label={t('viewerSidebar.enhance.render.stylePanel.title')}
    >
      <div className="style-panel__header">
        <span className="style-panel__title cgt-heading-50">
          {t('viewerSidebar.enhance.render.stylePanel.title')}
        </span>
        <Button
          type="ghost"
          variant="only-icon"
          size="small"
          actionType="button"
          icon={closeIcon}
          aria-label={t('viewerSidebar.enhance.render.stylePanel.close')}
          onClick={closeStylePanel}
        />
      </div>
      {/* Outside __content so the search and the categories stay put while the grid
          scrolls under them. */}
      <div className="style-panel__toolbar">
        <TextInput
          id="render-style-search"
          isPilot
          size="small"
          placeholder={t('viewerSidebar.enhance.render.stylePanel.searchPlaceholder')}
          value={query}
          onChange={handleQueryChange}
          leadIcon={searchIcon}
        />
        <StyleTags activeTagId={activeTagId} onSelectTag={handleSelectTag} />
      </div>
      <div className="style-panel__content" aria-busy={isLoading}>
        {isError
          ? (
            <p className="style-panel__status cgt-body-base" role="alert">
              {t('viewerSidebar.enhance.render.stylePanel.loadFailed')}
            </p>
          )
          : (
            <StyleGrid
              styles={visibleStyles}
              selectedStyleId={selectedStyleId}
              onSelectStyle={handleSelectStyle}
            />
          )}
      </div>
    </div>
  )
}

export default memo(StylePanel)
